import { render, staticRenderFns } from "./index.vue?vue&type=template&id=193ee666&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&module=styleTypography&"
import style1 from "./index.vue?vue&type=style&index=1&lang=scss&module=styleGrid&"
import style2 from "./index.vue?vue&type=style&index=2&lang=scss&module=styleMobileGrid&"
import style3 from "./index.vue?vue&type=style&index=3&lang=scss&module=styleSpacer&"
import style4 from "./index.vue?vue&type=style&index=4&lang=scss&module=true&"




function injectStyles (context) {
  
  this["styleTypography"] = (style0.locals || style0)
this["styleGrid"] = (style1.locals || style1)
this["styleMobileGrid"] = (style2.locals || style2)
this["styleSpacer"] = (style3.locals || style3)
this["$style"] = (style4.locals || style4)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports